import { language as lan_address } from "./address";
import { language as lan_list } from "./list";
import { language as lan_reordermodel } from "./reorder-model";

let language = {
    ...lan_address,
    ...lan_list,
    ...lan_reordermodel,
    // 获取银行转账信息审核状态-失败提示
    ORDER_DETAIL_GET_BANK_TRANSFER_FAILED_TITLE: "线下支付状态问题",
    ORDER_DETAIL_GET_BANK_TRANSFER_FAILED_CONTENT: "在查询线下支付状态时出现异常，请重试。如果问题仍然存在，请联系我们的支持团队，邮箱地址为{{supportmail}}。",
    // 订单不存在
    "A107B500201": "您要查找的订单未找到，或订单编号不正确。如果问题持续，请联系我们的支持团队，邮箱地址为{{supportmail}}。",
    // 非线下交易订单
    "A107B5400010": "这个订单不是银行转账订单。如果问题持续，请联系我们的支持团队，邮箱地址为{{supportmail}}。"
}

export { language }